/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q7Inputs */

const en_to_yaml_faq_q7 = /** @type {(inputs: To_Yaml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the greater than sign in my output?`)
};

const ko_to_yaml_faq_q7 = /** @type {(inputs: To_Yaml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력에 나온 부등호는 무엇인가요?`)
};

const ja_to_yaml_faq_q7 = /** @type {(inputs: To_Yaml_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力にある大なり記号は何ですか`)
};

/**
* | output |
* | --- |
* | "What is the greater than sign in my output?" |
*
* @param {To_Yaml_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q7 = /** @type {((inputs?: To_Yaml_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q7(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q7(inputs)
	return ja_to_yaml_faq_q7(inputs)
});